export const mapLink = "https://maps.app.goo.gl/H2mJYkDT8fkcbGGg6";
export const address = "Shop 1a, 24 Belgrave St (Back to Basics Chiropractic)";
export const address2 = "Kogarah NSW 2217";
export const phone = "(02) 9588 7000";
//export const mobile = "0488 388 992";
